var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0491 44.0002H14.2581C14.0238 44.0002 13.8208 43.8206 13.7895 43.5863L10.892 19.9061C10.8764 19.7734 10.9154 19.6405 11.0092 19.5391C11.095 19.4375 11.2279 19.3829 11.3606 19.3829L36.2122 19.3828C36.3449 19.3828 36.4778 19.4375 36.5637 19.539C36.6495 19.6405 36.6964 19.7733 36.673 19.906L33.5099 43.5862C33.4787 43.8283 33.2834 44.0002 33.0491 44.0002Z",
    fill: "#CBCBCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7275 20.3188H9.83771C9.57214 20.3188 9.35352 20.1001 9.35352 19.8346V16.0545C9.35352 15.7889 9.57223 15.5703 9.83771 15.5703H37.7275C37.9931 15.5703 38.2117 15.789 38.2117 16.0545V19.8346C38.2117 20.1002 37.993 20.3188 37.7275 20.3188Z",
    fill: "#797979"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.4554 20.3194H18.0996V17.9452C18.0996 17.6874 18.3105 17.4766 18.5682 17.4766H28.9868C29.2445 17.4766 29.4554 17.6874 29.4554 17.9452L29.4554 20.3194Z",
    fill: "#656666"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.6188 10.8841C31.5798 10.8841 31.533 10.8762 31.4939 10.8685C31.3956 10.8408 29.6036 10.4624 27.4689 9.99815L27.469 9.99824C27.4506 10.0635 26.8672 9.92306 26.0114 9.67916C23.0758 9.03206 20.065 8.33764 20.1015 8.20775L21.5035 8.28773C20.0572 7.82429 18.8935 7.44202 18.8025 7.41648C18.5526 7.34618 18.4042 7.08845 18.4745 6.83856L18.865 5.4093C18.9977 4.91726 19.318 4.51111 19.7553 4.25337C20.1927 4.00348 20.7081 3.93319 21.2002 4.06593L31.1188 6.76042C32.1342 7.03375 32.7355 8.08036 32.4544 9.09562L32.0639 10.5249C32.0094 10.7435 31.822 10.8841 31.6188 10.8841Z",
    fill: "#515151"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2707 39.9284H16.1385C15.8808 39.9284 15.6699 39.7176 15.6699 39.4598V23.9177C15.6699 23.6601 15.8808 23.4492 16.1385 23.4492H18.2707C18.5284 23.4492 18.7393 23.6601 18.7393 23.9177V39.4598C18.7393 39.7176 18.5284 39.9284 18.2707 39.9284ZM31.4228 39.9284H29.2907C29.0329 39.9284 28.8221 39.7176 28.8221 39.4598V23.9177C28.8221 23.6601 29.0329 23.4492 29.2907 23.4492H31.4228C31.6806 23.4492 31.8914 23.6601 31.8914 23.9177V39.4598C31.8914 39.7176 31.6806 39.9284 31.4228 39.9284ZM24.8467 39.9284H22.7147C22.4569 39.9284 22.246 39.7176 22.246 39.4598V23.9177C22.246 23.6601 22.4569 23.4492 22.7147 23.4492H24.8467C25.1045 23.4492 25.3153 23.6601 25.3153 23.9177V39.4598C25.3153 39.7176 25.1045 39.9284 24.8467 39.9284Z",
    fill: "#515151"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.7271 16.4994C37.6881 16.4994 37.6412 16.4915 37.6021 16.4838L10.6886 9.17341C10.4309 9.10312 10.2747 8.83754 10.345 8.57981L10.6886 7.33016C11.1182 5.74473 12.7583 4.80752 14.3359 5.23702L36.4462 11.2429C37.2116 11.4538 37.852 11.9458 38.2503 12.6332C38.6487 13.3205 38.7502 14.1249 38.5394 14.8903L38.2035 16.14C38.141 16.3588 37.938 16.4994 37.7271 16.4994Z",
    fill: "#797979"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.ed1b64948cc53904b2a861d3d0879855.svg";
export { ForwardRef as ReactComponent };